import dynamic from 'next/dynamic';

import { useFormContext } from 'react-hook-form';

import PersonalInformation from '@components/molecules/cpdEnrollment/personalInformation';
import { CPDEnrollmentFieldNames, CPDEnrollmentForm } from 'src/helpers/constants';
import { ICPDCourseEnrollment, ICPDCourse } from 'src/interfaces';

const LicenseInformation = dynamic(import('@components/molecules/cpdEnrollment/licenseInformation'));
const SelectRound = dynamic(import('@components/molecules/cpdEnrollment/selectRound'));
const ConfirmAllInformation = dynamic(import('@components/molecules/cpdEnrollment/confirmAllInformation'));

type EnrollmentContentProps = {
  totalSteps: number;
  currentStep: number;
  cpdCourseEnrollment: ICPDCourseEnrollment;
  cpdCourse: ICPDCourse;
  isEmailValid: boolean;
  handleNext: (data: CPDEnrollmentForm) => Promise<void>;
  initEnrollmentData: CPDEnrollmentForm | null;
};

const EnrollmentContentSteps = ({
  totalSteps,
  currentStep,
  cpdCourseEnrollment,
  cpdCourse,
  handleNext,
  isEmailValid,
  initEnrollmentData,
}: EnrollmentContentProps) => {
  const { watch, getValues, setValue } = useFormContext();
  const cpdEnrollmentForm = getValues() as CPDEnrollmentForm;

  setValue(CPDEnrollmentFieldNames.status, cpdCourseEnrollment?.status);
  setValue(CPDEnrollmentFieldNames.licenseRenewal, cpdCourse?.licenseRenewal);
  setValue(CPDEnrollmentFieldNames.isDeduct, cpdCourse?.isDeduct);
  setValue(CPDEnrollmentFieldNames.applicantType, cpdCourse?.applicantType);
  setValue(CPDEnrollmentFieldNames.licenseTypes, cpdCourse?.licenseTypes);
  setValue(CPDEnrollmentFieldNames.courseId, cpdCourse?.id);

  if (totalSteps === 4) {
    return (
      <>
        {currentStep === 1 && (
          <PersonalInformation
            isEmailValid={isEmailValid}
            initEnrollmentData={initEnrollmentData}
            citizenId={cpdCourseEnrollment.citizenId}
            email={cpdCourseEnrollment.email}
            profile={cpdCourseEnrollment.profile}
          />
        )}
        {currentStep === 2 && (
          <LicenseInformation customerLicenses={cpdCourseEnrollment.licenses} cpdCourses={[cpdCourse]} />
        )}
        {currentStep === 3 && (
          <SelectRound
            handleNext={handleNext}
            cpdCourseEnrollment={cpdCourseEnrollment}
            regulator={cpdCourse?.regulator}
            licenseRewnewal={cpdCourse?.licenseRenewal}
            licenseTypes={cpdCourse?.licenseTypes}
          />
        )}
        {currentStep === 4 && <ConfirmAllInformation cpdEnrollmentForm={cpdEnrollmentForm} cpdCourse={cpdCourse} />}
      </>
    );
  }
  return (
    <>
      {currentStep === 1 && (
        <PersonalInformation
          isEmailValid={isEmailValid}
          initEnrollmentData={initEnrollmentData}
          citizenId={cpdCourseEnrollment.citizenId}
          email={cpdCourseEnrollment.email}
          profile={cpdCourseEnrollment.profile}
        />
      )}
      {currentStep === 2 && (
        <SelectRound
          handleNext={handleNext}
          cpdCourseEnrollment={cpdCourseEnrollment}
          regulator={cpdCourse?.regulator}
          licenseRewnewal={cpdCourse?.licenseRenewal}
          licenseTypes={cpdCourse?.licenseTypes}
        />
      )}
      {currentStep === 3 && <ConfirmAllInformation cpdEnrollmentForm={cpdEnrollmentForm} cpdCourse={cpdCourse} />}
    </>
  );
};

export default EnrollmentContentSteps;
